import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import {
  INTERNSHIP_FUNCTIONS,
  InternshipFunction,
} from '#/utils/constants/general/internshipFunctions';

export function internshipKeywordsFacet(i18n: I18nFn) {
  return {
    id: 'internshipKeywordsFacet',
    name: 'functions',
    get title() {
      return i18n('Functions');
    },
    type: 'array',
    options: Object.keys(InternshipFunction),
    optionTitles: INTERNSHIP_FUNCTIONS(i18n),
  } as const satisfies SearchFacetData;
}
